import React, { useState } from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import LanguageSelectModal from "./LanguageSelectModal";

const timeSlots = [
  "03:00 - 06:00",
  "06:00 - 09:00",
  "09:00 - 12:00",
  "12:00 - 15:00",
  "15:00 - 18:00",
  "18:00 - 21:00",
  "21:00 - 24:00",
  "24:00 - 03:00",
];

const daysList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const FiltersModal = ({ show, onHide, filters, setFilters, onApply, hasActiveFilters, onClearFilters }) => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  const toggleTime = (slot) => {
    setFilters((prev) => {
      const updatedTimes = prev.times.includes(slot)
        ? prev.times.filter((t) => t !== slot)
        : [...prev.times, slot];
      return { ...prev, times: updatedTimes };
    });
  };

  const toggleDay = (day) => {
    setFilters((prev) => {
      const updatedDays = prev.days.includes(day)
        ? prev.days.filter((d) => d !== day)
        : [...prev.days, day];
      return { ...prev, days: updatedDays };
    });
  };

  const clearAllFilters = () => {
    setFilters({
      language: "",
      languageName: "",
      times: [],
      days: [],
    });
  };

  const handleLanguageSelect = (language) => {
    setFilters((prev) => ({ 
      ...prev, 
      language: language.id,
      languageName: language.name
    }));
    setShowLanguageModal(false);
  };

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Clear Filters Button */}
          {hasActiveFilters && (
            <div className="mb-3">
              <Button variant="outline-danger" size="sm" onClick={clearAllFilters}>
                Clear All Filters
              </Button>
            </div>
          )}

          {/* Preferred Language */}
          <div
            className="d-flex justify-content-between align-items-center border p-2 mb-3 rounded"
            style={{ cursor: "pointer" }}
            onClick={() => setShowLanguageModal(true)}
          >
            <div>
              <strong>Preferred language</strong>
              <div className="text-muted mt-1">
                {filters.languageName || "All languages"}
                {/* {filters.language && filters.language !== "all" && (
                  <Badge bg="primary" className="ms-2">
                    ID: {filters.language}
                  </Badge>
                )} */}
              </div>
            </div>
            <i className="fa fa-chevron-right"></i>
          </div>

          {/* Times Available */}
          <div className="mb-3">
            <strong>Times available</strong>
            <div className="d-flex flex-wrap mt-2 gap-2">
              {timeSlots.map((slot) => (
                <Button
                  key={slot}
                  variant={filters.times.includes(slot) ? "primary" : "outline-primary"}
                  onClick={() => toggleTime(slot)}
                  size="sm"
                  className="flex-grow-0"
                >
                  {slot}
                </Button>
              ))}
            </div>
            {filters.times.length > 0 && (
              <small className="text-muted mt-2 d-block">
                Selected: {filters.times.length} time slot{filters.times.length > 1 ? 's' : ''}
              </small>
            )}
          </div>

          {/* Days Available */}
          <div className="mb-3">
            <strong>Days available</strong>
            <div className="d-flex flex-wrap mt-2 gap-2">
              {daysList.map((day) => (
                <Button
                  key={day}
                  variant={filters.days.includes(day) ? "primary" : "outline-primary"}
                  onClick={() => toggleDay(day)}
                  size="sm"
                  className="flex-grow-0"
                >
                  {day}
                </Button>
              ))}
            </div>
            {filters.days.length > 0 && (
              <small className="text-muted mt-2 d-block">
                Selected: {filters.days.length} day{filters.days.length > 1 ? 's' : ''}
              </small>
            )}
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="primary" className="w-100" onClick={onApply}>
            View All Tutors
          </Button>
        </Modal.Footer> */}
      </Modal>

      {/* Language Selection Modal */}
      <LanguageSelectModal
        show={showLanguageModal}
        onHide={() => setShowLanguageModal(false)}
        onSelectLanguage={handleLanguageSelect}
        selectedLanguageId={filters.language}
      />
    </>
  );
};

export default FiltersModal;